<template>
  <main class="main">
    <router-link
      v-for="(item, index) in exhibitions.data"
      :key="item.uid"
      :to="{ name: 'exhibition', params: { id: item.uid } }"
    >
      <div class="year">
        <span v-if="checkDuplicate(index, item.year)" class="indent">{{
          item.year
        }}</span>
      </div>
      {{ item.title }}
    </router-link>
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "exhibitions",
  metaInfo() {
    return {
      title: "- Exhibitions"
    };
  },
  computed: {
    ...mapState(["exhibitions"])
  },
  methods: {
    checkDuplicate(index, year) {
      if (index === 0) {
        return true;
      } else {
        let previousYear = this.exhibitions.data[index - 1].year;
        if (previousYear === year) {
          return false;
        } else {
          return true;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  display: flex;
}
.year {
  width: 8rem;
  display: inline-block;
  flex: 0 0 auto;
  color: black;
  @media only screen and (max-width: 768px) {
    width: 16rem;
  }
}
</style>
